import { render, staticRenderFns } from "./CredentialsEdit.vue?vue&type=template&id=6dac4e05"
import script from "./CredentialsEdit.vue?vue&type=script&lang=js"
export * from "./CredentialsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports